import Index from './index';

const RecyclingContractOrder = () => {
  return <Index type={2} />;
};

export default RecyclingContractOrder;
